import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqInstagramPosts = {
	listPaginate: async function (param, paramValue, active, page) {
		return apiServer
			.get("portal/v1/instagram/post", {
				params: {
					param,
					paramValue,
					active,
					page,
					perpage: 15,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response; // Revert to returning the entire response
			})
			.catch((error) => {
				throw error;
			});
	},
	listPaginateDM: async function (param, paramValue, active, page) {
		return apiServer
			.get("portal/v1/instagram/dm", {
				params: {
					param,
					paramValue,
					active,
					page,
					perpage: 15,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response; // Revert to returning the entire response
			})
			.catch((error) => {
				throw error;
			});
	},
	listID: async function (id) {
		return apiServer
			.get(`portal/v1/instagram/post/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	insert: async function (data) {
		return apiServer
			.post("portal/v1/instagram/post", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqInstagramPosts;
